module.exports = __webpack_public_path__ + "static/media/galerija_2022_0019.1335ead6.jpg";